import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { MINUTES } from '~/shared/lib/time-constants'
import { profileLinksApi } from '../api/profile-links-api'

/** Pulsify profiles connected to the business; they answer requests from the app. */
export function useProfileLinks(businessId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.BUSINESS_PROFILE_LINKS, businessId),
    queryFn: () => profileLinksApi.list(businessId),
    staleTime: 5 * MINUTES,
    enabled: !!businessId,
  })
}

function useRefreshLinks(businessId: string) {
  const queryClient = useQueryClient()
  return () =>
    queryClient.invalidateQueries({
      queryKey: queryKey(QueryKey.BUSINESS_PROFILE_LINKS, businessId),
    })
}

export function useLinkProfile(businessId: string) {
  const refresh = useRefreshLinks(businessId)
  return useMutation({
    mutationFn: (code: string) => profileLinksApi.link(businessId, code),
    onSuccess: refresh,
  })
}

export function useUnlinkProfile(businessId: string) {
  const refresh = useRefreshLinks(businessId)
  return useMutation({
    mutationFn: (userProfileId: string) => profileLinksApi.unlink(businessId, userProfileId),
    onSuccess: refresh,
  })
}
